import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent implements OnInit {
  @Input() config: { name: string, class: string, fullScreen?: boolean };

  constructor(private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

    if (!this.config) {
      this.spinner.show();
    }

  }
}
